import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import { ListingStateEnum } from "utils/Enums";
import { RaiseColors } from "components/mui";
var ListingStateColorMapStyles = function ListingStateColorMapStyles() {
  return {
    purpleChip: {
      background: RaiseColors.grape
    },
    greenChip: {
      background: RaiseColors.onMarket
    },
    orangeChip: {
      background: RaiseColors.warning
    },
    watermelonChip: {
      background: RaiseColors.alarm
    },
    blueChip: {
      background: RaiseColors.blue
    },
    grayChip: {
      background: RaiseColors.gray200
    },
    purpleLabel: {
      color: RaiseColors.grape
    },
    greenLabel: {
      color: RaiseColors.onMarket
    },
    orangeLabel: {
      color: RaiseColors.warning
    },
    watermelonLabel: {
      color: RaiseColors.alarm
    },
    blueLabel: {
      color: RaiseColors.blue
    },
    grayLabel: {
      background: RaiseColors.gray200
    }
  };
};
var colorClassNamesMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ListingStateEnum.PREDICTED.value, "purpleChip"), ListingStateEnum.ON_MARKET.value, "greenChip"), ListingStateEnum.IN_PROPOSALS.value, "orangeChip"), ListingStateEnum.IN_LEASES.value, "orangeChip"), ListingStateEnum.LEASED.value, "watermelonChip"), ListingStateEnum.DEAD.value, "watermelonChip"), ListingStateEnum.NOT_AVAILABLE.value, "grayChip");
var colorClassLabelMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ListingStateEnum.PREDICTED.label, "purpleChip"), ListingStateEnum.ON_MARKET.label, "greenChip"), ListingStateEnum.IN_PROPOSALS.label, "orangeChip"), ListingStateEnum.IN_LEASES.label, "orangeChip"), ListingStateEnum.LEASED.label, "watermelonChip"), ListingStateEnum.DEAD.label, "watermelonChip"), ListingStateEnum.NOT_AVAILABLE.label, "grayChip");
var colorClassNamesLabelMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ListingStateEnum.PREDICTED.value, "purpleLabel"), ListingStateEnum.ON_MARKET.value, "greenLabel"), ListingStateEnum.IN_PROPOSALS.value, "orangeLabel"), ListingStateEnum.IN_LEASES.value, "orangeLabel"), ListingStateEnum.LEASED.value, "watermelonLabel"), ListingStateEnum.DEAD.value, "watermelonLabel"), ListingStateEnum.NOT_AVAILABLE.value, "grayLabel");
export { colorClassNamesMap, colorClassNamesLabelMap, colorClassLabelMap, ListingStateColorMapStyles };